import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const SERVICE_LINKS = [
  { label: "FTL & Partial Loads", to: "/services#ftl-partial-loads", testid: "footer-service-ftl" },
  { label: "Dedicated Transportation", to: "/services#dedicated", testid: "footer-service-dedicated" },
  { label: "Expedite & Hot Shot", to: "/services#expedite", testid: "footer-service-expedite" },
  { label: "Specialized & White-Glove Delivery", to: "/services#specialized", testid: "footer-service-specialized" },
  { label: "3PL & Freight Brokerage", to: "/services#3pl", testid: "footer-service-3pl" },
];

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#191c1e] text-white">
      <div className="container-30 grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8 lg:py-20">
        <div className="lg:col-span-4">
          <Link to="/" data-testid="footer-logo-link" aria-label="30 NORTH — Home" className="inline-block">
            <span className="inline-flex items-center bg-white px-5 py-3">
              <img src="/assets/logo.png" alt="30 NORTH Transportation logo" className="h-8 w-auto" />
            </span>
            <span className="block h-[3px] w-14 bg-[#ff6a00]" aria-hidden="true" />
          </Link>
          <p className="mt-6 text-sm font-semibold tracking-wide text-white">30 North Transportation Inc.</p>
          <p className="mt-1 text-sm text-white/60">Transportation Solutions & 3PL</p>
          <p className="mt-4 flex items-center gap-3 text-sm text-white/60">
            <span className="block h-px w-6 bg-[#ff6a00]" aria-hidden="true" />
            Moving North America Forward
          </p>
        </div>

        <nav aria-label="Footer services" className="lg:col-span-3">
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Services</h3>
          <ul className="mt-5 space-y-3">
            {SERVICE_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={l.testid}
                  className="text-sm text-white/70 transition-colors duration-200 hover:text-[#ff6a00]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="lg:col-span-2">
          <nav aria-label="Footer company">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Company</h3>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/capacity" data-testid="footer-company-capacity" className="text-sm text-white/70 transition-colors duration-200 hover:text-[#ff6a00]">
                  Transportation Options
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-company-about" className="text-sm text-white/70 transition-colors duration-200 hover:text-[#ff6a00]">
                  About
                </Link>
              </li>
            </ul>
          </nav>
          <nav aria-label="Footer get started" className="mt-8">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Get Started</h3>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/request-a-quote" data-testid="footer-quote-link" className="text-sm font-semibold text-[#ff6a00] transition-colors duration-200 hover:text-white">
                  Request a Quote
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="lg:col-span-3">
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#ff6a00]" aria-hidden="true" />
              <span data-testid="footer-address">
                2907 - 80 Absolute Ave
                <br />
                Mississauga, ON L4Z 0A5
                <br />
                Canada
              </span>
            </li>
            <li>
              <a href="tel:6138700294" data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors duration-200 hover:text-[#ff6a00]">
                <Phone className="h-4 w-4 shrink-0 text-[#ff6a00]" aria-hidden="true" />
                613-870-0294
              </a>
            </li>
            <li>
              <a href="mailto:operations@30north.ca" data-testid="footer-email-link" className="flex items-center gap-3 break-all transition-colors duration-200 hover:text-[#ff6a00]">
                <Mail className="h-4 w-4 shrink-0 text-[#ff6a00]" aria-hidden="true" />
                operations@30north.ca
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#2b2f33]">
        <div className="container-30 flex flex-col items-start justify-between gap-4 py-6 text-xs text-white/50 sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">© 2026 30 North Transportation Inc. All Rights Reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="transition-colors duration-200 hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" data-testid="footer-terms-link" className="transition-colors duration-200 hover:text-white">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
